import { render, staticRenderFns } from "./SoPromocodeCard.vue?vue&type=template&id=31e93a7b"
import script from "./SoPromocodeCard.vue?vue&type=script&lang=js"
export * from "./SoPromocodeCard.vue?vue&type=script&lang=js"
import style0 from "./SoPromocodeCard.vue?vue&type=style&index=0&id=31e93a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports